import React from "react";
import { Box, TextField, Typography } from "@mui/material";
import SettingsPrimaryButton from "../shared/SettingsPrimaryButton";
import SettingsSecondaryButton from "../shared/SettingsSecondaryButton";
import {
  COLORS,
  CONTENT_MAX_WIDTH,
  FONT,
  cardDescSx,
} from "../shared/styles";
import { DownloadIcon } from "./icons";

const featureIconSx = {
  width: 64,
  height: 64,
  borderRadius: "8px",
  border: `1px solid ${COLORS.border}`,
  background: COLORS.white,
  boxShadow: COLORS.shadow,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  flexShrink: 0,
};

const featureTitleSx = {
  color: COLORS.textPrimary,
  fontFamily: FONT.family,
  fontSize: "18px",
  fontWeight: 500,
  lineHeight: "34px",
  m: 0,
};

const backupCodeFieldSx = {
  width: 312,
  maxWidth: "100%",
  "& .MuiOutlinedInput-root": {
    height: "40px",
    borderRadius: "8px",
    fontFamily: FONT.family,
    fontSize: "14px",
    fontWeight: 400,
    color: COLORS.textPrimary,
    boxShadow: COLORS.shadow,
    background: COLORS.white,
    "& fieldset": {
      borderColor: COLORS.border,
    },
  },
  "& .MuiOutlinedInput-input": {
    py: 0,
    px: "12px",
  },
};

function BackupCodesSection({
  codes,
  onDownload,
  onRegenerate,
  regenerateLoading = false,
}) {
  return (
    <Box>
      <Box sx={{ display: "flex", alignItems: "center", gap: "16px" }}>
        <Box sx={featureIconSx}>
          <DownloadIcon />
        </Box>
        <Box sx={{ flex: 1, minWidth: 0 }}>
          <Typography component="p" sx={featureTitleSx}>
            Backup Codes
          </Typography>
          <Typography component="p" sx={cardDescSx}>
            Save these codes in a secure location. Each can be used once if
            you lose access to your authenticator.
          </Typography>
        </Box>
      </Box>

      {codes.length ? (
        <Box
          sx={{
            display: "grid",
            gridTemplateColumns: "repeat(2, 312px)",
            gap: "8px",
            mt: "24px",
            maxWidth: CONTENT_MAX_WIDTH,
            "@media (max-width: 768px)": {
              gridTemplateColumns: "1fr",
            },
          }}
        >
          {codes.map((code) => (
            <TextField
              key={code}
              value={code}
              InputProps={{ readOnly: true }}
              sx={backupCodeFieldSx}
            />
          ))}
        </Box>
      ) : null}

      <Box sx={{ mt: "24px", display: "flex", gap: "12px", flexWrap: "wrap" }}>
        <SettingsPrimaryButton type="button" onClick={onDownload} disabled={!codes.length}>
          Download backup codes
        </SettingsPrimaryButton>
        {onRegenerate ? (
          <SettingsSecondaryButton
            type="button"
            onClick={onRegenerate}
            disabled={regenerateLoading}
          >
            {regenerateLoading ? "Regenerating…" : "Regenerate codes"}
          </SettingsSecondaryButton>
        ) : null}
      </Box>
    </Box>
  );
}

export default BackupCodesSection;
